'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as RadixTooltip } from '@radix-ui/themes';
import { cloneElement, isValidElement, useEffect, useState, useRef, useCallback, } from 'react';
const enhanceChildWithRef = (children, ref) => {
    if (!isValidElement(children))
        return null;
    return cloneElement(children, {
        ref: (element) => {
            ref.current = element;
        },
    });
};
export const Tooltip = ({ showOnOverflow = false, open, children, ...tooltipProps }) => {
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const checkTruncation = useCallback(() => {
        const element = elementRef.current;
        if (!element)
            return;
        const truncated = element.scrollWidth > element.clientWidth;
        setIsTruncated(truncated);
    }, []);
    useEffect(() => {
        if (!showOnOverflow)
            return;
        const element = elementRef.current;
        if (!element)
            return;
        checkTruncation();
        const resizeObserver = new ResizeObserver(checkTruncation);
        const mutationObserver = new MutationObserver(mutations => {
            const hasRelevantChanges = mutations.some(mutation => mutation.type === 'attributes' &&
                (mutation.attributeName === 'class' || mutation.attributeName === 'style'));
            if (hasRelevantChanges) {
                requestAnimationFrame(checkTruncation);
            }
        });
        if (element.parentElement) {
            resizeObserver.observe(element.parentElement);
        }
        const elementsToObserve = [
            element,
            element.parentElement,
            element.parentElement?.parentElement,
        ].filter((el) => el !== null);
        elementsToObserve.forEach(el => {
            mutationObserver.observe(el, {
                attributes: true,
                attributeFilter: ['class', 'style'],
            });
        });
        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [checkTruncation, showOnOverflow]);
    if (!showOnOverflow) {
        return (_jsx(RadixTooltip, { className: "rt-Tooltip", open: open, ...tooltipProps, children: children }));
    }
    return (_jsx(RadixTooltip, { className: "rt-Tooltip", open: isTruncated ? open : false, ...tooltipProps, children: enhanceChildWithRef(children, elementRef) }));
};
//# sourceMappingURL=tooltip.js.map